import ProductName from '@web/components/ProductName'

type Card = {
  title: string
  tag: string
  body: React.ReactNode
}

const cards: Card[] = [
  {
    title: 'Less Crown safety net',
    tag: 'September 2025',
    body: (
      <>
        Cabinet&apos;s September 2025 decision signalled a Crown withdrawal from post-event buyouts.
        Your consent and LIM decisions carry sharper legal and political weight than they did in
        mid-2025.
      </>
    ),
  },
  {
    title: 'New LIM regulations live',
    tag: '17 October 2025',
    body: (
      <>
        Since 17 October 2025, all councils must present natural hazard information in LIMs in a
        consistent, regulated format, with mandatory disclosure of known hazards and a transparent
        methodology.
      </>
    ),
  },
  {
    title: 'NPS-NH in force',
    tag: '15 January 2026',
    body: (
      <>
        The National Policy Statement for Natural Hazards 2025 came into force on 15 January 2026.
        Councils must now have regard to it when making consent decisions. Seven hazards. A
        standardised risk matrix. A direction to use the best available information. Excludes
        infrastructure and primary production (clause 1.3(2)).
      </>
    ),
  },
  {
    title: 'Council amalgamation ahead',
    tag: '2028 outlook',
    body: (
      <>
        The amalgamation and Planning Bill reforms are moving councils towards 17 regional combined
        plans and fewer, larger entities. <ProductName /> works at district scale today and at
        regional scale tomorrow. Your hazard evidence base and risk records travel with whatever
        entity emerges in 2028.
      </>
    ),
  },
]

const RegulatoryDrivers = () => {
  return (
    <section className="bg-white py-24 sm:py-16">
      <div className="space-y-10 mx-auto max-w-5xl px-6 lg:px-8">
        <div className="space-y-3">
          <span className="text-xs font-semibold uppercase tracking-widest text-brand-blue">
            What changed in 2025 and 2026
          </span>
          <h2 className="text-4xl font-light text-brand-blue">
            Four shifts have changed what councils have to disclose, and how.
          </h2>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {cards.map((c) => (
            <div
              key={c.title}
              className="border-0 border-l-4 border-solid border-brand-blue pl-5 space-y-3"
            >
              <div className="space-y-1">
                <span className="text-xs uppercase tracking-wider font-semibold text-brand-blue">
                  {c.tag}
                </span>
                <h3 className="text-xl font-semibold text-brand-navy m-0">{c.title}</h3>
              </div>
              <p className="text-base text-brand-navy leading-relaxed m-0">{c.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default RegulatoryDrivers
